'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = require('@/components/page');

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Decorate() {
  var decorateList = {
    console: function console() {
      var g = window;
      var logMaps = ['log', 'warn', 'error'];
      g.console = g.console || {};
      logMaps.forEach(function (item) {
        if (!g.console[item]) g.console[item] = function () {};
      });
    }
  };
  return {
    add: function add(namespace, fn) {
      if (decorateList[namespace]) {
        console.wran(namespace + ' \u5DF2\u5B58\u5728');
        return;
      }
      decorateList[namespace] = fn;
    },
    exec: function exec() {
      for (var i in decorateList) {
        decorateList[i] && decorateList[i].apply(this, arguments);
      }
    }
  };
}
var decorate = Decorate();
//兼容IE9下tabs animate默认值
decorate.add('iview-tabs', function (Vue) {
  var UA = window.navigator.userAgent.toLowerCase();
  var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
  if (isIE9) Vue.options.components.Tabs.options.props.animated.default = false;
});
//自定义翻页组件
decorate.add('iview-page', function (Vue) {
  Vue.options.components.Page = _page2.default;
});
//修正poptip无法完全展示
decorate.add('iview-poptip', function (Vue) {
  var options = Vue.options.components.DatePicker.options;
  options.props.transfer.default = true;
});
exports.default = {
  install: function install(Vue, options) {
    decorate.exec.apply(this, arguments);
  }
};